/** Strings for the navigation bar (niup-navbar): brand, nav links, notifications
 *  bell, profile menu and the sign-out confirmation popup. */
export const navbar = {
  // Brand logo alt text / aria-label.
  brand: 'niup.me',
  // Top navigation links.
  links: {
    home: 'Home',
    companies: 'Companies',
    people: 'People',
    permissionGroups: 'Permission groups',
    activity: 'Activity',
  },
  // Notifications bell button.
  notifications: {
    label: 'Notifications',
    // aria-label when there are unread notifications.
    labelUnread: 'Notifications ({count} unread)',
  },
  // Profile avatar button and dropdown menu.
  profile: {
    menu: 'Profile menu',
    userAlt: 'User',
    myProfile: 'My profile',
    signOut: 'Sign out',
  },
  // Sign-out confirmation popup.
  logout: {
    title: 'Sign out?',
    message: 'Are you sure you want to sign out of your account?',
    confirm: 'Sign out',
  },
};
